<template>
  <div class="login">
    <div class="bg">
        <div class="form">
            <p  v-show="isPrompt" class="prompt">{{message}}</p>
            <div class="item">
                <input type="number"  :placeholder="Name"  v-model="username" class="name" @focus="name">
            </div>
            <div class="item">
                <input type="password" :placeholder="Password"  v-model="password" class="psd" @focus="Psd">
            </div>
              <p class="register" @click="register">注册</p>
        </div>
        <div class="btn">
            <img src="../../assets/images/active/login.png" alt="" class="btn_image">
            <p class="font">登录</p>
            <div class="mocen" @click="login"></div>
        </div>
        <div class="motail" v-show="isMotail">
          <div class="motailin" >
          <p class="title">我是谜app打开方式</p>
          <p class="item">1.点击右上角[...]</p>
          <p class="item">2.用[浏览器打开]  注册</p>
          </div>
        </div>
    </div>
    
  </div>
</template>
<script>
import axios from "axios"
export default {
  data() {
    return {
      isMotail:false,
      Name:"账号",
      Password:"密码",
      username: "",
      password: "",
      token:"",
      userguid:"",
      isPrompt:false,
      message:""
    };
  },
  created() {
     document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
    localStorage.getItem("token")
  },
  methods: {
    login() {
      if (this.username == "") {
        this.isPrompt=true
        this.message="用户名不能为空"
      } else if (this.password == "") {
        this.isPrompt=true
        this.message="密码不能为空"
      } else{
        axios.post(this.$interfaces.login, {
            phoneNum: this.username,
            pwd: this.password
          })
          .then(res => {
            if(res.data.code===200){
            this.token = res.data.data.token
            this.userguid = res.data.data.userGuid
            this.userid=res.data.data.userId;
            this.$store.dispatch('Token',this.token)
            this.$store.dispatch('UserGuid',this.userguid)
            localStorage.setItem("token",this.token)
            localStorage.setItem("userguid",this.userguid)
            localStorage.setItem("userid",this.userid)
            this.$store.dispatch('UserId',this.userid)
            
            if(!this.$store.state.otheruserguid){
              this.$router.push("/start")
            }else{
              this.$router.push("/otherhome/"+this.$store.state.otheruserguid)
            }
            }else{
              this.isPrompt=true
              this.message=res.data.message
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    name(){
      this.isPrompt=false
      this.username=""
      this.Name=""
      
    },
    Psd(){
      this.isPrompt=false
      this.password=""
      this.isPrompt=false
      this.Password=""
    },
     register() {
          var ua = navigator.userAgent.toLowerCase();
            if (
              ua.match(/MicroMessenger/i) == "micromessenger" ||
              ua.match(/QQ/i) == "qq"
            ) {
              this.isMotail=true;
            } else {
              window.location.href ="mvoicerwsm://";//苹果
              window.location.href = "mvoicerwsm://openapp";//安卓
              //记录唤醒时间
              var openTime = +new Date();
              window.setTimeout(function() {
                if (+new Date() - openTime > 1000) {
                  window.location.href = "https://share.mvoicer.com/#/open";
                }
              }, 1500);
      }
    }
   
  }
};
</script>
<style scoped>
.login {
  width: 100%;
  height: 100%;
}
.login .bg{
    background:url("../../assets/images/active/bg/bglogin.png")left top no-repeat;
    background-size: cover;
    height: 33.35rem;   
    position:relative;
    display: flex;
    justify-content: center;
}
.login .bg .motail{
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  height: 33.35rem;
  background:rgba(0,0,0,.5);
  display: flex;
  justify-content: center;
  
}
.login .bg .motail .motailin{
  padding-top:0.5rem;
  position: absolute;
  top:35%;
  width: 6rem;
  height: 3.75rem;
  background:white;
  border-radius: 0.5rem;
}
.login .bg .motail .motailin .title{
  font-size:0.625rem;
  margin-bottom:0.375rem;
}
.login .bg .motail .motailin  .item{
  font-size:0.6rem;
  margin-top:0.375rem;
  
}
.login .bg .form{
  position:absolute;
  top:10.75rem;
  width:16rem;
  height:9.075rem; 
  padding-top:0.75rem;
  padding-left:0.25rem;
  padding-right:0.25rem;
  /* border:0.025rem solid red; */
  
}
.login .bg .form .item{
  width:15.5rem;
  height: 2.5rem;
  border-radius: 1.25rem;
  overflow: hidden;
  margin-bottom:1.5rem;
  position:relative;
  
}
.login .bg .form .item:last-child{
  margin-bottom:1.5rem;
}
.login .bg .form .item .name{
  caret-color:rgba(0,0,0,.2);
  position:absolute;
  top:0;
  left:0;
  border:none;
  width:15.5rem;
  height: 2.5rem;
  font-size:1.05rem;
  font-family:SourceHanSansCN-Regular;
  font-weight:400;
  color:pink;
  line-height: 1rem;
  text-align: center
}
.login .bg .form .item .psd{
  caret-color:rgba(0,0,0,.2);
  position:absolute;
  top:0;
  left:0;
  border:none;
  width:15.5rem;
  height: 2.5rem;
  font-size:1.05rem;
  font-family:SourceHanSansCN-Regular;
  font-weight:400;
  color:pink;
  line-height: 1rem;
  text-align: center

}
.login .bg .form .prompt{
    position: absolute;
    top:0;
    text-align: center;
    color:white; 
    width:16rem;

   
}
.login .bg .form .register{
    padding-right:0.875rem;
    width:16rem;
    position: absolute;
    bottom:0;
    text-align: center;
    font-size:0.6rem;
    font-family:SourceHanSansCN-Regular;
    font-weight:400;
    color:rgba(117,86,98,1);
} 
.login .bg .btn{
    position: absolute;
    bottom:9.875rem;
    width:16rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    color:white;
    font-size: 1rem;
}
.login .bg .btn .mocen{
    width:16rem;
    height: 3rem;
    position: absolute;
    left:0;
    top:0;
    /* background:pink; */
    
}
.login .bg .btn .font{
    position: absolute;
    top:0;
    left:0;
    width:16rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    color:white;
    font-size: 1rem;
}
.login .bg .btn img{
    width:100%;
    height: 100%;
}
::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:pink;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    pink;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:  pink;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color: pink;
}
/* 白边为10像素 */
</style>





// WEBPACK FOOTER //
// src/components/active/login.vue